const fr = {
  nav: {
    home: "Accueil",
    about: "À propos",
    services: "Services",
    industries: "Industries",
    whyUs: "Pourquoi Nous",
    contact: "Contact",
    portal: "Portail Client",
  },
  mobileNav: {
    home: "Accueil",
    projects: "Portefeuille",
    applications: "Candidatures",
    profile: "Profil",
  },
  about: {
    badge: "À propos",
    title: "Qui sommes-nous,",
    titleHighlight: "Cloud Mature?",
    description: "Cloud Mature est une entreprise de technologies de l'information basée à Conakry, dont la vocation est d'accompagner les organisations dans leur transformation vers le Cloud, qu'il soit public, privé ou hybride, avec une approche sécurisée, performante et conforme aux standards les plus élevés. Experts certifiés Microsoft, AWS et Google Cloud, nous concevons des architectures multi-cloud robustes et guidons les organisations dans leur transformation numérique avec rigueur, proximité et engagement.",
    missions: [
      { title: "Architectures Multi-Cloud", desc: "Conception d'infrastructures sur Azure, AWS et GCP - du cloud public au cloud privé - avec des architectures résilientes, scalables et optimisées pour votre contexte métier." },
      { title: "Excellence opérationnelle", desc: "Automatisation CI/CD, Infrastructure-as-Code (Terraform, Bicep, CloudFormation), monitoring avancé et gouvernance FinOps pour maximiser votre retour sur investissement." },
      { title: "Intelligence Artificielle", desc: "Déploiement de solutions IA sur Azure OpenAI, AWS Bedrock et Google Vertex AI. Intégration de Microsoft Copilot et automatisation intelligente de vos processus métiers." },
      { title: "Accompagnement sur mesure", desc: "Partenariat de proximité avec des équipes locales certifiées, disponibles et engagées. Solutions personnalisées adaptées à chaque secteur d'activité." },
      { title: "Sécurité, Souveraineté & Conformité", desc: "Architectures orientées cloud souverain et résidence des données, politiques Zero Trust, Microsoft Defender, AWS Security Hub, Google Chronicle. Conformité ISO 27001, SOC 2 et RGPD pour protéger vos actifs numériques." },
      { title: "Renforcement des compétences", desc: "Formation et coaching sur les écosystèmes Microsoft, AWS et GCP pour garantir l'autonomie technologique et la pérennité de votre transformation." },
    ],
  },
  hero: {
    words: ["Innover.", "Optimiser.", "Automatiser."],
    badge: { consulting: "Consultation", cloud: "Cloud", devops: "DevOps", ai: "IA" },
    description: "Cloud Mature accompagne les organisations dans leur transformation vers le Cloud, qu'il soit public, privé ou hybride, avec une approche sécurisée, performante et conforme aux standards les plus élevés.",
    cta: "Demander une consultation",
    become: "Devenir client",
    multiCloud: "Multi-Cloud",
    multiCloudDesc: "AWS, Azure, GCP",
    security: "Sécurité",
    securityDesc: "ISO 27001, SOC 2",
    finops: "FinOps",
    finopsDesc: "Optimisation coûts",
  },
  services: {
    badge: "Nos Services",
    title: "Ce que nous",
    titleHighlight: "livrons concrètement",
    subtitle: "Licences, équipements, solutions sur mesure - nous fournissons l'ensemble des produits et prestations nécessaires à votre infrastructure Cloud, hybride ou privée.",
    imageCaption: "L'expertise au service de votre transformation",
    items: [
      { title: "Écosystème Microsoft 365 & Azure", desc: "Déploiement et gestion de Microsoft 365, Azure, Entra ID, Intune, Defender et Power Platform. Licences CSP/EA, migrations Exchange/SharePoint et adoption utilisateur." },
      { title: "Licences & Souscriptions Cloud", desc: "Fourniture de licences Microsoft, AWS et Google Workspace. Gestion des renouvellements, optimisation des coûts et consolidation multi-éditeurs." },
      { title: "Infrastructures Hybrides & Privées", desc: "Livraison d'équipements serveurs, stockage et réseau. Intégration Azure Stack HCI, AWS Outposts, VMware et solutions hyperconvergées pour vos datacenters." },
      { title: "Architecture, Ingénierie & Migration Cloud", desc: "Conception multi-cloud (Azure, AWS, GCP) en Infrastructure-as-Code (Terraform, Bicep), Kubernetes et microservices. Migration Lift & Shift ou refactoring (Azure Migrate, AWS Migration Hub) et modernisation des workloads avec zéro interruption." },
      { title: "Développement d'apps métier modernes", desc: "Conception et développement d'applications métier sur mesure : web, mobile et SaaS. Architectures cloud-native, API-first, intégration à vos systèmes (ERP, CRM, SharePoint) et IA générative embarquée." },
      { title: "Sécurité & Conformité", desc: "Microsoft Defender & Sentinel, AWS Security Hub, Google Chronicle. Politiques Zero Trust, gestion des identités et conformité ISO 27001, SOC 2, RGPD." },
      { title: "Infogérance & Support Managé", desc: "Surveillance proactive 24/7 multi-cloud, support N1 à N3, gestion des incidents, monitoring des performances et suivi SLA contractuel." },
      { title: "IA & Automatisation Intelligente", desc: "Microsoft Copilot, Azure OpenAI, AWS Bedrock et Google Vertex AI. Automatisation des processus et intégration IA dans vos outils métiers." },
      { title: "Cloud Souverain & Résidence des Données", desc: "Une priorité forte de Cloud Mature. Nous concevons des architectures orientées cloud souverain : choix de régions et zones de disponibilité conformes, chiffrement géré par le client (BYOK/HYOK), cloisonnement réseau, traçabilité et hébergement local lorsque la réglementation l'exige. Adapté aux acteurs publics, financiers, de santé et stratégiques." },
    ],
  },
  industries: {
    badge: "Industries",
    title: "À qui s'adressent",
    titleHighlight: "nos services?",
    subtitle: "Nous concevons des architectures Cloud et des solutions IA adaptées aux exigences spécifiques de chaque secteur, sur Microsoft Azure, AWS et Google Cloud.",
    items: [
      { title: "Banques & Finance", desc: "Infrastructures Azure et AWS conformes PCI-DSS, architectures haute disponibilité, IA pour la détection de fraude et l'analyse prédictive." },
      { title: "Assurances", desc: "Migration des systèmes legacy vers le Cloud, automatisation des processus de souscription et gestion intelligente des sinistres avec l'IA." },
      { title: "Compagnies Minières", desc: "Edge computing et IoT sur Azure IoT Hub et AWS IoT Core, connectivité hybride pour sites distants, maintenance prédictive par IA." },
      { title: "Gouvernements & Secteur Public", desc: "Clouds souverains, architectures conformes aux exigences de résidence des données, transformation numérique des services publics." },
      { title: "Startups & Scale-ups", desc: "Architectures serverless sur Azure Functions, AWS Lambda et GCP Cloud Run. Infrastructure évolutive et CI/CD pour accélérer le time-to-market." },
      { title: "Télécoms & IT", desc: "Modernisation des infrastructures réseau, conteneurisation Kubernetes (AKS, EKS, GKE), DevOps et observabilité avancée." },
    ],
    learnMore: "En savoir plus →",
  },
  microsoft: {
    badge: "Partenaire Microsoft",
    title: "Microsoft 365 + Copilot",
    subtitle: "Licences officielles, migration sécurisée, adoption et intégration de l'IA Microsoft dans vos processus métiers.",
    valueProps: [
      { title: "Licences officielles", desc: "Bénéficiez de licences Microsoft 365, Azure et Copilot via un partenaire CSP agréé, avec des tarifs préférentiels et un support local." },
      { title: "Migration en douceur", desc: "Nous accompagnons vos équipes dans la migration de vos messageries, fichiers et applications vers le cloud Microsoft." },
      { title: "Intelligence Artificielle", desc: "Déployez Microsoft Copilot dans vos outils quotidiens pour augmenter la productivité et automatiser vos tâches répétitives." },
    ],
    whyTitle: "Pourquoi choisir Microsoft 365 avec Cloud Mature ?",
    whyText: "En tant que partenaire Microsoft, Cloud Mature vous accompagne de l'audit de votre environnement actuel à la formation de vos utilisateurs. Nous assurons la conformité, la sécurité et la performance de votre écosystème Microsoft, tout en vous aidant à tirer le meilleur parti de l'IA générative avec Copilot.",
    offerTitle: "Notre offre comprend",
    offerItems: [
      "Conseil et audit de votre environnement Microsoft",
      "Fourniture de licences Microsoft 365, Azure et Copilot",
      "Migration Exchange, SharePoint, OneDrive et Teams",
      "Déploiement et configuration de Copilot",
      "Formation et adoption utilisateur",
      "Support managé et infogérance",
    ],
    ctaTitle: "Prêt à transformer votre travail avec Microsoft 365 ?",
    ctaText: "Demandez un devis gratuit pour vos licences Microsoft 365 et Copilot. Notre équipe vous répond sous 24 heures.",
    ctaButton: "Demander un devis",
    infographicHint: "Cliquez pour agrandir l'infographie",
  },
  whyUs: {
    badge: "Avantages",
    title: "Pourquoi choisir",
    titleHighlight: "Cloud Mature?",
    items: [
      { title: "Expertise Microsoft & Multi-Cloud", desc: "Partenaire Microsoft certifié, avec des compétences avancées sur AWS et Google Cloud pour des architectures hybrides et multi-cloud." },
      { title: "Solutions sur mesure", desc: "De l'architecture à la livraison - licences, équipements, développement applicatif et intégration IA adaptés à votre métier." },
      { title: "Résultats mesurables", desc: "KPIs contractuels, SLA garantis, reporting FinOps et tableaux de bord en temps réel pour un suivi transparent." },
      { title: "Sécurité & Souveraineté", desc: "Zero Trust, SIEM/SOAR (Sentinel, Security Hub), architectures orientées cloud souverain et résidence des données, conformité ISO 27001, SOC 2 et RGPD sur toutes les plateformes." },
      { title: "Équipe locale certifiée", desc: "Ingénieurs basés à Conakry, certifiés Azure, AWS et GCP, disponibles et réactifs pour un accompagnement de proximité." },
      { title: "Bilingue FR/EN", desc: "Documentation, support et formation en français et en anglais pour une couverture régionale et internationale." },
    ],
  },
  contact: {
    badge: "Contact",
    title: "Parlons de votre",
    titleHighlight: "projet Cloud",
    subtitle: "Contactez-nous pour une consultation gratuite et découvrez comment Cloud Mature peut transformer votre infrastructure.",
    namePlaceholder: "Votre nom *",
    emailPlaceholder: "Email *",
    companyPlaceholder: "Entreprise *",
    messagePlaceholder: "Votre message *",
    send: "Envoyer",
    sending: "Envoi...",
    successTitle: "Message envoyé!",
    successDesc: "Nous vous répondrons dans les meilleurs délais.",
    errorTitle: "Erreur",
    errorDesc: "Veuillez réessayer.",
    validationName: "Le nom est requis.",
    validationEmail: "L'email est requis.",
    validationEmailInvalid: "Veuillez entrer un email valide.",
    validationCompany: "L'entreprise est requise.",
    validationMessage: "Le message est requis.",
  },
  footer: {
    copyright: "© {year} Cloud Mature. Tous droits réservés. Innover · Optimiser · Automatiser",
    privacy: "Politique de confidentialité",
    terms: "Conditions d'utilisation",
    partners: "Nos partenaires",
  },
  privacy: {
    title: "Politique de confidentialité",
    lastUpdated: "Dernière mise à jour : avril 2026",
    sections: [
      { title: "1. Introduction", content: "Cloud Mature s\u2019engage \u00e0 prot\u00e9ger la vie priv\u00e9e des utilisateurs de ses services et de son site web. La pr\u00e9sente politique d\u00e9crit les donn\u00e9es que nous collectons, comment nous les utilisons et les mesures que nous prenons pour les prot\u00e9ger." },
      { title: "2. Données collectées", content: "Nous collectons les informations que vous nous fournissez directement : nom, adresse e-mail, numéro de téléphone, nom de l'entreprise, ainsi que toute information communiquée via nos formulaires de contact ou le portail client.\n\nNous collectons également des données techniques de manière automatique : adresse IP, type de navigateur, pages consultées et durée de visite." },
      { title: "3. Utilisation des données", content: "Vos données sont utilisées pour :\n• Fournir et améliorer nos services Cloud, DevOps et IA\n• Gérer votre compte sur le portail client\n• Communiquer avec vous concernant vos projets et demandes de support\n• Assurer la sécurité de nos systèmes\n• Respecter nos obligations légales" },
      { title: "4. Partage des données", content: "Nous ne vendons jamais vos données personnelles. Nous pouvons les partager avec :\n• Nos sous-traitants techniques (hébergement Cloud, envoi d'e-mails) dans le cadre strict de la prestation\n• Les autorités compétentes en cas d'obligation légale\n\nTous nos partenaires sont soumis à des obligations de confidentialité." },
      { title: "5. Sécurité", content: "Nous mettons en œuvre des mesures de sécurité conformes aux standards de l'industrie : chiffrement des données en transit et au repos, authentification multi-facteurs, politiques Zero Trust, contrôle d'accès basé sur les rôles (RBAC) et surveillance continue de nos infrastructures." },
      { title: "6. Conservation des données", content: "Vos données sont conservées aussi longtemps que nécessaire pour fournir nos services ou respecter nos obligations légales. Les données de compte sont supprimées dans les 30 jours suivant la clôture de votre compte." },
      { title: "7. Vos droits", content: "Conformément à la réglementation applicable, vous disposez des droits suivants :\n• Accès à vos données personnelles\n• Rectification des informations inexactes\n• Suppression de vos données\n• Opposition au traitement\n• Portabilité de vos données\n\nPour exercer ces droits, contactez-nous à info@cloudmature.com." },
      { title: "8. Cookies", content: "Notre site utilise des cookies essentiels au fonctionnement (session, préférences de langue). Aucun cookie publicitaire ou de suivi tiers n'est utilisé." },
      { title: "9. Contact", content: "Pour toute question relative à cette politique, contactez-nous :\nCloud Mature - Conakry, Guinée\nE-mail : info@cloudmature.com" },
    ],
  },
  terms: {
    title: "Conditions d'utilisation",
    lastUpdated: "Dernière mise à jour : avril 2026",
    sections: [
      { title: "1. Objet", content: "Les présentes conditions générales d'utilisation (« CGU ») régissent l'accès et l'utilisation du site web et du portail client de Cloud Mature, entreprise de technologies de l'information spécialisée en Cloud, DevOps et Intelligence Artificielle." },
      { title: "2. Acceptation", content: "En accédant à nos services ou en créant un compte sur le portail client, vous acceptez sans réserve les présentes CGU. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser nos services." },
      { title: "3. Description des services", content: "Cloud Mature fournit des services de conseil, d'architecture et d'ingénierie Cloud multi-cloud (Microsoft Azure, AWS, Google Cloud), incluant :\n• Licences et abonnements Cloud (Microsoft 365, Azure, AWS, Google Workspace)\n• Équipements pour infrastructures hybrides et privées\n• Solutions de sécurité et conformité\n• Services managés et support technique\n• Intégration d'Intelligence Artificielle" },
      { title: "4. Compte utilisateur", content: "L'accès au portail client nécessite la création d'un compte. Vous êtes responsable de la confidentialité de vos identifiants et de toute activité effectuée sous votre compte. L'authentification multi-facteurs (MFA) est obligatoire pour tous les utilisateurs." },
      { title: "5. Obligations de l'utilisateur", content: "Vous vous engagez à :\n• Fournir des informations exactes et à jour\n• Compléter votre profil dans les 30 jours suivant la création du compte\n• Ne pas tenter d'accéder à des ressources non autorisées\n• Respecter les lois et réglementations applicables\n• Ne pas utiliser nos services à des fins illicites" },
      { title: "6. Propriété intellectuelle", content: "L'ensemble du contenu du site et du portail (textes, images, logos, code source) est la propriété exclusive de Cloud Mature ou de ses partenaires. Toute reproduction, distribution ou utilisation non autorisée est strictement interdite." },
      { title: "7. Limitation de responsabilité", content: "Cloud Mature s'efforce d'assurer la disponibilité et la fiabilité de ses services. Toutefois, nous ne garantissons pas un accès ininterrompu. Notre responsabilité est limitée au montant des services effectivement facturés dans les 12 mois précédant l'événement donnant lieu à réclamation." },
      { title: "8. Confidentialité", content: "Les informations échangées dans le cadre de nos prestations sont strictement confidentielles. Chaque partie s'engage à ne pas divulguer les informations confidentielles de l'autre partie sans autorisation préalable écrite." },
      { title: "9. Résiliation", content: "Vous pouvez supprimer votre compte à tout moment depuis votre profil. Cloud Mature se réserve le droit de suspendre ou résilier un compte en cas de violation des présentes CGU, sans préavis." },
      { title: "10. Droit applicable", content: "Les présentes CGU sont régies par le droit applicable en République de Guinée. Tout litige sera soumis aux juridictions compétentes de Conakry." },
      { title: "11. Contact", content: "Pour toute question concernant ces conditions :\nCloud Mature - Conakry, Guinée\nE-mail : info@cloudmature.com" },
    ],
  },
  auth: {
    portalTitle: "Portail Client",
    backToSite: "Retour au site",
    continueGoogle: "Continuer avec Google",
    or: "ou",
    fullName: "Nom complet",
    email: "Email",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Déjà un compte ?",
    signup: "S'inscrire",
    login: "Se connecter",
    sendLink: "Envoyer le lien",
    loading: "Chargement...",
    sendingLink: "Envoi...",
    backToLogin: "Retour à la connexion",
    signupSuccess: "Inscription réussie!",
    signupSuccessDesc: "Vérifiez votre email pour confirmer votre compte.",
    emailSent: "Email envoyé!",
    emailSentDesc: "Vérifiez votre boîte de réception pour réinitialiser votre mot de passe.",
    blocked: "Compte bloqué",
    blockedDesc: "Votre compte a été suspendu. Veuillez contacter l'administrateur à info@cloudmature.com.",
    suspended: "Compte suspendu",
    suspendedDesc: "Votre accès a été restreint. Contactez info@cloudmature.com pour plus d'informations.",
    error: "Erreur",
    phoneTab: "Téléphone",
    emailTab: "Email",
    phone: "Numéro de téléphone (E.164)",
    phonePlaceholder: "+1234567890",
    sendSmsCode: "Envoyer le code par SMS",
    sendingSmsCode: "Envoi...",
    enterSmsCode: "Entrez le code à 6 chiffres reçu par SMS",
    verifySmsCode: "Vérifier le code",
    verifyingSmsCode: "Vérification...",
    smsSent: "SMS envoyé!",
    smsSentDesc: "Vérifiez votre téléphone pour le code de vérification.",
    smsError: "Erreur SMS",
    smsVerified: "Vérification réussie!",
    smsVerifiedDesc: "Vous êtes maintenant connecté.",
    smsInvalidCode: "Code invalide ou expiré",
    smsRateLimit: "Trop de tentatives. Veuillez patienter 10 minutes.",
    twilioTrial: "Note : Twilio trial - seuls les numéros vérifiés peuvent recevoir des SMS.",
  },
  mfa: {
    title: "Vérification MFA",
    subtitle: "Authentification à deux facteurs",
    backToLogin: "Retour à la connexion",
    initialSetup: "Configuration initiale",
    scanQr: "Scannez ce QR code avec votre application d'authentification (Google Authenticator, Authy, etc.)",
    manualCode: "Ou entrez ce code manuellement :",
    enterCode: "Entrez le code à 6 chiffres",
    activateMfa: "Activer le MFA",
    verifying: "Vérification...",
    verificationRequired: "Vérification requise",
    verificationDesc: "Entrez le code de votre application d'authentification pour accéder au portail.",
    verify: "Vérifier",
    success: "Vérification réussie!",
    successDesc: "Accès au portail autorisé.",
    invalidCode: "Code invalide",
    smsOption: "SMS",
    totpOption: "Authentificateur",
    emailOption: "Courriel",
    sendSmsCode: "Envoyer le code SMS",
    sendingSmsCode: "Envoi...",
    smsSendDesc: "Nous enverrons un code de vérification à votre téléphone",
    enterSmsCode: "Entrez le code reçu par SMS",
    smsVerify: "Vérifier le code SMS",
    smsSent: "Code envoyé!",
    smsSentDesc: "Vérifiez votre téléphone pour le code de vérification.",
    noPhone: "Aucun numéro de téléphone",
    noPhoneDesc: "Ajoutez un numéro de téléphone à votre profil pour utiliser la vérification par SMS.",
    sendEmailCode: "Envoyer le code par courriel",
    sendingEmailCode: "Envoi...",
    emailSendDesc: "Nous enverrons un code de vérification à votre courriel",
    enterEmailCode: "Entrez le code reçu par courriel",
    emailVerify: "Vérifier le code courriel",
    emailSent: "Code envoyé!",
    emailSentDesc: "Vérifiez votre boîte de réception pour le code de vérification.",
  },
  resetPassword: {
    title: "Nouveau mot de passe",
    subtitle: "Choisissez un nouveau mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    update: "Mettre à jour",
    updating: "Mise à jour...",
    success: "Mot de passe mis à jour!",
    successDesc: "Vous pouvez maintenant vous connecter.",
    invalidLink: "Lien invalide",
    invalidLinkDesc: "Ce lien de réinitialisation est invalide ou a expiré.",
    mismatch: "Les mots de passe ne correspondent pas.",
    tooShort: "Le mot de passe doit contenir au moins 6 caractères.",
    backToLogin: "Retour à la connexion",
  },
  portal: {
    loading: "Chargement...",
    dashboard: "Tableau de bord",
    projects: "Mon Portefeuille",
    support: "Support",
    profile: "Profil",
    admin: "Administration",
    agentSpace: "Espace Agent",
    logout: "Déconnexion",
    welcome: "Bienvenue,",
    overview: "Voici un aperçu de votre espace client.",
    refresh: "Actualiser",
    activeProjects: "Portefeuille actif",
    openTickets: "Tickets ouverts",
    completed: "Complétés",
    avgProgress: "Progression moy.",
    myActivity: "Mon activité",
    projectsByStatus: "Portefeuille par statut",
    recentProjects: "Portefeuille récent",
    latestTickets: "Derniers tickets",
    noProjects: "Aucun portefeuille pour le moment",
    noTickets: "Aucun ticket pour le moment",
    noData: "Aucune donnée",
    noProjectsOrTickets: "Aucun portefeuille ou ticket pour le moment.",
    teamWillAdd: "Votre équipe CloudMature ajoutera vos portefeuilles ici.",
    total: "total",
    inProgress: "En cours",
    done: "Terminé",
    pending: "En attente",
    open: "Ouvert",
    resolved: "Résolu",
    closed: "Fermé",
    average: "en moyenne",
    deadline: "Échéance",
    urgent: "Urgent",
    high: "Haute",
    normal: "Normal",
    myProjects: "Mon Portefeuille",
    submitProject: "Soumettre un portefeuille",
    cancel: "Annuler",
    search: "Rechercher un portefeuille...",
    statusFilter: "Statut :",
    all: "Tous",
    newProject: "Nouveau portefeuille",
    editProject: "Modifier le portefeuille",
    projectName: "Nom du portefeuille *",
    projectNamePlaceholder: "Ex: Refonte du site web",
    description: "Description",
    descriptionPlaceholder: "Décrivez votre portefeuille, vos besoins et objectifs...",
    estimatedBudget: "Budget estimé",
    budgetPlaceholder: "Ex: 5000 - 10000 $",
    desiredDeadline: "Délai souhaité",
    selectDate: "Sélectionner une date",
    desiredServices: "Services souhaités",
    priority: "Priorité",
    attachments: "Pièces jointes",
    addFiles: "Ajouter des fichiers",
    submit: "Soumettre",
    save: "Enregistrer",
    submitting: "Envoi en cours...",
    projectSubmitted: "Portefeuille soumis!",
    projectSubmittedDesc: "Votre portefeuille a été envoyé avec succès.",
    projectEdited: "Portefeuille modifié!",
    projectEditedDesc: "Les modifications ont été enregistrées.",
    noProjectsYet: "Aucun portefeuille",
    noProjectsYetDesc: "Soumettez votre premier portefeuille pour commencer.",
    progress: "Progression",
    budget: "Budget",
    technologies: "Services",
    created: "Créé le",
    modify: "Modifier",
    attachedFiles: "Fichiers joints",
    supportTickets: "Support",
    openTicketCount: "ouverts",
    inProgressCount: "en cours",
    resolvedCount: "résolus",
    newTicket: "Nouveau ticket",
    subject: "Sujet *",
    subjectPlaceholder: "Résumez votre demande",
    message: "Message *",
    messagePlaceholder: "Décrivez votre problème ou votre demande en détail...",
    sendTicket: "Envoyer le ticket",
    ticketSent: "Ticket envoyé!",
    ticketSentDesc: "Notre équipe vous répondra rapidement.",
    filterAll: "Tous",
    noTicketsYet: "Aucun ticket",
    noTicketsYetDesc: "Créez un ticket pour contacter le support.",
    conversation: "Conversation",
    noReplies: "Aucune réponse pour le moment.",
    you: "Vous",
    team: "Équipe",
    replyPlaceholder: "Votre réponse...",
    send: "Envoyer",
    myProfile: "Mon Profil",
    fullName: "Nom complet",
    company: "Entreprise",
    phone: "Téléphone",
    saveProfile: "Enregistrer",
    saving: "Enregistrement...",
    profileSaved: "Profil mis à jour!",
    profileSavedDesc: "Vos informations ont été enregistrées.",
    deleteAccount: "Supprimer mon compte",
    deleteAccountConfirm: "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.",
    accountDeleted: "Compte supprimé",
    accountDeletedDesc: "Votre compte a été marqué pour suppression.",
    profileIncomplete: "Veuillez compléter votre profil (nom, entreprise, téléphone) dans les {days} jour{s} restants.",
    profileOverdue: "Le délai de 30 jours pour compléter votre profil est dépassé. Veuillez le remplir immédiatement.",
    completeProfile: "Compléter mon profil",
    project: "portefeuille",
    projects_count: "portefeuille(s)",
    ticket: "ticket",
    tickets_count: "ticket(s)",
  },
  admin: {
    loading: "Chargement...",
    overview: "Vue d'ensemble",
    projects: "Portefeuille",
    tickets: "Tickets",
    contacts: "Contacts",
    users: "Utilisateurs",
    portalClient: "Portail client",
    logout: "Déconnexion",
    admin: "Admin",
    agent: "Agent",
    hello: "Bonjour,",
    agentDesc: "Voici votre espace agent - gérez les tickets clients.",
    overviewTitle: "Vue d'ensemble",
    overviewDesc: "Suivez l'activité de votre plateforme en temps réel.",
    refresh: "Actualiser",
    openTickets: "Tickets ouverts",
    inProgressTickets: "En cours",
    resolvedTickets: "Résolus",
    myReplies: "Mes réponses",
    recentTickets: "Tickets récents à traiter",
    pending: "en attente",
    noTicketsToProcess: "Aucun ticket à traiter 🎉",
    registeredClients: "Clients inscrits",
    totalProjects: "Portefeuille total",
    totalBudget: "Budget total",
    active: "actifs",
    monthlyActivity: "Activité mensuelle",
    projectsByStatus: "Portefeuille par statut",
    ticketsByStatus: "Tickets par statut",
    latestSignups: "Derniers inscrits",
    recentProjects: "Portefeuille récent",
    noData: "Aucune donnée",
  },
  sharepoint: {
    title: "SharePoint",
    description: "Parcourez vos sites SharePoint, fichiers et listes.",
    filesTab: "Fichiers",
    listsTab: "Listes",
    invoicesTab: "Factures",
    selectSite: "Sélectionnez un site SharePoint",
    searchSites: "Rechercher des sites...",
    noSites: "Aucun site SharePoint trouvé.",
    selectDrive: "Sélectionnez une bibliothèque de documents",
    upload: "Uploader",
    uploading: "Upload en cours...",
    uploadSuccess: "Fichier uploadé avec succès !",
    newFolder: "Nouveau dossier",
    folderCreated: "Dossier créé avec succès !",
    folderNamePlaceholder: "Nom du dossier",
    cancel: "Annuler",
    create: "Créer",
    emptyFolder: "Ce dossier est vide.",
    emptyList: "Cette liste est vide.",
    items: "éléments",
    error: "Erreur SharePoint",
    listsTitle: "Listes SharePoint",
    noLists: "Aucune liste trouvée.",
    searchFiles: "Rechercher des fichiers...",
    noResults: "Aucun fichier correspondant.",
  },
  install: {
    title: "Installer CloudMature",
    subtitle: "Ajoutez l'application à votre écran d'accueil pour y accéder comme une app native.",
    ios1: "Appuyez sur le bouton Partager en bas de Safari.",
    ios2: "Sélectionnez « Sur l'écran d'accueil ».",
    ios3: "Confirmez en appuyant sur « Ajouter ».",
    android1: "Appuyez sur le menu ⋮ en haut à droite de Chrome.",
    android2: "Sélectionnez « Installer l'application » ou « Ajouter à l'écran d'accueil ».",
    navButton: "Télécharger l'app",
  },
} as const;

export default fr;
